module.exports = __webpack_public_path__ + "35bc932c35240e06bf7f05cb7c7bf9ae.pdf";